(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/routes.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/routes.js');
'use strict';

const PlayerLogin = svs.playerLoginReact.login.PlayerLogin;
const PlayerRegistrate = svs.playerLoginReact.registrate.PlayerRegistrate;
const BankIdPoll = svs.playerLoginReact.bankid.BankIdPoll;
const FrejaeIdPoll = svs.playerLoginReact.frejaeid.FrejaeIdPoll;
const _svs$playerLoginReact = svs.playerLoginReact.constants,
  route = _svs$playerLoginReact.route,
  bankIdPollType = _svs$playerLoginReact.bankIdPollType,
  appWaitStatus = _svs$playerLoginReact.appWaitStatus,
  frejaeIdPollType = _svs$playerLoginReact.frejaeIdPollType;
const Route = svs.app.ReactRouter.Route;
const Routes = () => {
  const dispatch = ReactRedux.useDispatch();
  const returnUrl = ReactRedux.useSelector(state => state.playerloginreact.returnUrl);
  const setReturnUrl = svs.playerLoginReact.store.playerloginreactactions.setReturnUrl;
  React.useEffect(() => {
    const handleGetReturnUrl = data => {
      if (data) {
        dispatch(setReturnUrl(data));
      }
    };
    if (returnUrl && returnUrl !== '/tur') {
      svs.components.Storage.browser.set('returnUrl', 'player-login', returnUrl, svs.components.Storage.constants.EXPIRES_10M, () => {});
    } else {
      svs.components.Storage.browser.get('returnUrl', 'player-login', data => {
        handleGetReturnUrl(data);
      });
    }
  }, []);
  React.useEffect(() => {
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(Route, {
    exact: true,
    path: route.LOGIN_HOME_ROUTE,
    render: () => React.createElement(PlayerLogin, {
      isBankId: true,
      isHome: true
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.LOGIN_BANKID_ROUTE,
    render: () => React.createElement(PlayerLogin, {
      isBankId: true
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.LOGIN_FREJAEID_ROUTE,
    render: () => React.createElement(PlayerLogin, {
      isBankId: false
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.REGISTRATE_HOME_ROUTE,
    render: () => React.createElement(PlayerRegistrate, {
      isBankId: true
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.REGISTRATE_BANKID_ROUTE,
    render: () => React.createElement(PlayerRegistrate, {
      isBankId: true
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.REGISTRATE_FREJAEID_ROUTE,
    render: () => React.createElement(PlayerRegistrate, {
      isBankId: false
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.LOGIN_BANKID_START_ROUTE,
    render: () => React.createElement(BankIdPoll, {
      isLogin: true,
      pollState: bankIdPollType.BEFORE_POLL
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.LOGIN_BANKID_POLL_QR_ROUTE,
    render: () => React.createElement(BankIdPoll, {
      bankIdPollWait: appWaitStatus.WAITING_QRCODE,
      isLogin: true,
      pollState: bankIdPollType.WAITING_POLL
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.LOGIN_BANKID_POLL_APP_ROUTE,
    render: () => React.createElement(BankIdPoll, {
      bankIdPollWait: appWaitStatus.WAITING_APP,
      isLogin: true,
      pollState: bankIdPollType.WAITING_POLL
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.REGISTRATE_BANKID_START_ROUTE,
    render: () => React.createElement(BankIdPoll, {
      isLogin: false,
      pollState: bankIdPollType.BEFORE_POLL
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.REGISTRATE_BANKID_POLL_QR_ROUTE,
    render: () => React.createElement(BankIdPoll, {
      bankIdPollWait: appWaitStatus.WAITING_QRCODE,
      isLogin: false,
      pollState: bankIdPollType.WAITING_POLL
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.REGISTRATE_BANKID_POLL_APP_ROUTE,
    render: () => React.createElement(BankIdPoll, {
      bankIdPollWait: appWaitStatus.WAITING_APP,
      isLogin: false,
      pollState: bankIdPollType.WAITING_POLL
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.LOGIN_FREJAEID_START_ROUTE,
    render: () => React.createElement(FrejaeIdPoll, {
      frejaeIdPollWait: appWaitStatus.WAITING_APP,
      isLogin: true,
      pollState: frejaeIdPollType.BEFORE_POLL
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.LOGIN_FREJAEID_POLL_QR_ROUTE,
    render: () => React.createElement(FrejaeIdPoll, {
      frejaeIdPollWait: appWaitStatus.WAITING_QRCODE,
      isLogin: true,
      pollState: frejaeIdPollType.WAITING_POLL
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.LOGIN_FREJAEID_POLL_APP_ROUTE,
    render: () => React.createElement(FrejaeIdPoll, {
      frejaeIdPollWait: appWaitStatus.WAITING_APP,
      isLogin: true,
      pollState: frejaeIdPollType.WAITING_POLL
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.REGISTRATE_FREJAEID_POLL_ROUTE,
    render: () => React.createElement(FrejaeIdPoll, {
      frejaeIdPollWait: appWaitStatus.WAITING_APP,
      isLogin: false,
      pollState: frejaeIdPollType.BEFORE_POLL
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.REGISTRATE_FREJAEID_POLL_QR_ROUTE,
    render: () => React.createElement(FrejaeIdPoll, {
      frejaeIdPollWait: appWaitStatus.WAITING_QRCODE,
      isLogin: false,
      pollState: frejaeIdPollType.WAITING_POLL
    })
  }), React.createElement(Route, {
    exact: true,
    path: route.REGISTRATE_FREJAEID_POLL_APP_ROUTE,
    render: () => React.createElement(FrejaeIdPoll, {
      frejaeIdPollWait: appWaitStatus.WAITING_APP,
      isLogin: false,
      pollState: frejaeIdPollType.WAITING_POLL
    })
  }));
};
svs.playerLoginReact.Routes = Routes;

 })(window);